module.exports = __webpack_public_path__ + "feature-request-tracking-2-b7cb8667e13e8772b523518bddd6570a.webp";